<template>
  <BasicLayout>
    <template #wrapper>
      <el-card :bordered="false" :body-style="{padding: '0'}">

        <div class="salesCard">
          <el-form :inline="true">
            <el-form-item label="开始日期">
              <el-date-picker
                v-model="queryParams1.startDate"
                placeholder="请选择日期"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="结束日期">
              <el-date-picker
                v-model="queryParams1.endDate"
                placeholder="请选择日期"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-button :loadin="loading" type="primary" icon="el-icon-search" size="mini" @click="handleQuery(0)">查询</el-button>
              <!--              <el-button v-if="isExport" type="primary" icon="el-icon-download" size="mini" @click="handleQuery(1)">导出</el-button>-->
            </el-form-item>
          </el-form>
          <div ref="chartContainer" style="width: 100%; height: 400px;" />
        </div>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import echarts from 'echarts'
import { getReportRateStat } from '@/api/statistics/user_remain'
import { dateStrTodate, getLastDates } from '@/utils'

require('echarts/theme/macarons') // echarts theme

export default {
  name: 'ReportRate',
  props: {
    isExport: {
      Type: Boolean,
      default: true
    }
  },
  data() {
    return {
      data2: {},
      loading: false,
      chartData: {},
      queryParams1: {
        startDate: '',
        endDate: '',
        type: 1,
        level: 0
      },
      types: [{ label: '登录类型', value: 1 }, { label: '进入游戏', value: 2 }],
      chart: {}
    }
  },
  created() {
    this.queryParams1.startDate = getLastDates(7)
    this.queryParams1.endDate = getLastDates(1)
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleQuery(isExport = 0) {
      if (!this.queryParams1.startDate) {
        this.msgError('开始日期不能为空')
        return
      }

      if (!this.queryParams1.endDate) {
        this.msgError('结束日期不能为空')
        return
      }
      this.initChart(isExport)
    },
    initChart(isExport = 0) {
      const chart = echarts.init(this.$refs.chartContainer)
      chart.showLoading()
      this.loading = true
      const option = {
        title: {
          text: '重要事件统计'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        data2: {},
        type2: {},
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        toolbox: {
          show: true
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            console.log('option.data2', option.data2)
            console.log('params', params)
            let tooltipContent = ''
            params.forEach(function(item) {
              const _date = item.axisValue
              let process = '0/0'
              const seriesName = item.seriesName
              const keyArr = option.type2
              if (option.data2[_date]) {
                const valObj = option.data2[_date]
                const key = keyArr[seriesName]
                if (valObj[key]) {
                  process = valObj[key]
                }
              }
              const dynamicName = `${seriesName} (${process})` // 根据需要自定义名称
              tooltipContent += `${dynamicName}: ${item.data}<br/>`
            })

            return tooltipContent
          }
        },
        series: []
      }
      chart.setOption(option)
      setTimeout(() => {
        const types2 = {}
        const data = {}
        const data2 = {}
        const types = {
          open_push_rate: '推送通知打开率',
          open_auto_rate: '推送通知授权率',
          // reg_success_rate: '注册成功率',
          guide_rate: '引导成功率',
          attack_down_rate: '打下载成功率',
          down_level_rate: '关卡下载成功率',
          down_map_rate: '棋盘下载成功率'
          // steal_rate: '偷下载成功率',
          // sp_steal_rate: '特殊偷成功率',
          // act_down_rate: '活动下载成功率'
        }

        for (const i in types) {
          types2[types[i]] = i
        }
        getReportRateStat(this.queryParams1).then(res => {
          this.loading = false
          this.loading = false
          chart.hideLoading()
          if (res.code === 200) {
            // if (this.queryParams1.level === 1) {
            //   window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
            // }
            if (res.data.length < 1) {
              return
            }
            const dateArr = {}
            const date = []
            const legend = []

            res.data.data.forEach(item => {
              const _date = dateStrTodate(item.date)
              if (dateArr[_date] === undefined) {
                dateArr[_date] = 1
                date.push(_date)
              }
              data2[_date] = item.data
              for (const key in types) {
                if (data[key] === undefined) {
                  data[key] = []
                }
                if (item[key] !== undefined) {
                  data[key].push(item[key])
                }
              }
            })
            for (const i in data) {
              legend.push(types[i])
              const temp = {
                name: types[i],
                data: data[i],
                type: 'line',
                smooth: true,
                label: {
                  show: true,
                  position: 'top', // 标签显示在折线图顶部
                  formatter: '{c}' // 显示数值
                }
              }
              option.series.push(temp)
            }
            option.data2 = data2
            option.type2 = types2
            option.legend.data = legend
            option.xAxis.data = date
            chart.setOption(option, true)
          } else {
            this.msgError(res.msg)
          }
        })
        // const titleArr = ['推送成功(20/200)', '推送授权(20/200)', '引导成功(20/200)', '打下载成功(20/200)', '关卡下载(20/200)', ' 地图下载(20/200)', '活动下载(20/200)']
        // chart.graphic.style.text = titleArr.join('\r\n')
        // chart.setOption(option, true)
      }, 800)
    }
  }
}
</script>

  <style scoped />
